<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2d0" id="heading_id_2"><a id="page_vi"></a><a id="page_vii"></a>CONTENTS</h2>
<p class="toc"><span><a id="intro"></a><a href="#/Text/introduction#intro1">Introduction</a></span></p>
<p class="toc1"><span><a href="#/Text/introduction#intro1">Prayer—It’s Not about You</a></span></p>
<p class="toc"><span><a id="ch1"></a><a href="#/Text/chapter_001#ch_1">Chapter 1</a></span></p>
<p class="toc1"><span><a href="#/Text/chapter_001#ch_1">The Problem of Prayer</a></span></p>
<p class="toc"><span><a id="ch2"></a><span href="#/Text/chapter_002#ch_2" title="Link target outside of Sample">Chapter 2</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_002#ch_2" title="Link target outside of Sample">Cats and Dogs Examine the Model Prayer</span></span></p>
<p class="toc"><span><a id="ch3"></a><span href="#/Text/chapter_003#ch_3" title="Link target outside of Sample">Chapter 3</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_003#ch_3" title="Link target outside of Sample">Learning to Ask Big</span></span></p>
<p class="toc"><span><a id="ch4"></a><span href="#/Text/chapter_004#ch_4" title="Link target outside of Sample">Chapter 4</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_004#ch_4" title="Link target outside of Sample">The Purposes of Prayer</span></span></p>
<p class="toc"><span><a id="ch5"></a><span href="#/Text/chapter_005#ch_5" title="Link target outside of Sample">Chapter 5</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_005#ch_5" title="Link target outside of Sample">Don’t Bless Me Like That!</span></span></p>
<p class="toc"><span><a id="ch6"></a><span href="#/Text/chapter_006#ch_6" title="Link target outside of Sample">Chapter 6</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_006#ch_6" title="Link target outside of Sample">Beware and Be Aware in Prayer</span></span></p>
<p class="toc"><span><a id="ch7"></a><span href="#/Text/chapter_007#ch_7" title="Link target outside of Sample">Chapter 7</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_007#ch_7" title="Link target outside of Sample">The Timing of God’s Answers</span></span></p>
<p class="toc"><span><a id="ch8"></a><span href="#/Text/chapter_008#ch_8" title="Link target outside of Sample">Chapter 8</span></span></p>
<p class="toc1"><span><span href="#/Text/chapter_008#ch_8" title="Link target outside of Sample">Why Does God Say No?</span></span></p>
<p class="toc"><span><a id="bm1"></a><span href="#/Text/backmatter_001#bm_1" title="Link target outside of Sample">Prayers God Can’t Answer</span></span></p>
<p class="toc1"><span><span href="#/Text/backmatter_001#bm_1" title="Link target outside of Sample">Final Thoughts from Gerald</span></span></p>
<p class="toc"><span><a id="bm2"></a><span href="#/Text/backmatter_002#bm_2" title="Link target outside of Sample">Putting the “Super” in Supernatural</span></span></p>
<p class="toc1"><span><span href="#/Text/backmatter_002#bm_2" title="Link target outside of Sample">Final Thoughts from Bob</span></span></p>
<p class="toc"><span><a id="note"></a><span href="#/Text/notes#note1" title="Link target outside of Sample">Notes</span></span></p>
<p class="toc"><span><a id="author"></a><span href="#/Text/author#author1" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1d3e8d39